import { PatientsService } from '../patients.service';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingsService } from './../settings.service';
import { FormControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { ChangeDetectorRef } from '@angular/core';
import Keyboard from "simple-keyboard";
import layout from "simple-keyboard-layouts/build/layouts/hebrew";

@Component({
  standalone: false,
  selector: 'app-card-reader',
  templateUrl: './card-reader.component.html',
  styleUrls: ['./card-reader.component.scss']
})
export class CardReaderComponent implements OnInit {
  @ViewChild('swipeField') swipeField: ElementRef;
  @ViewChild('prnField') prnField: ElementRef;
  @ViewChild('refferDocField') refferDocField: ElementRef;
  @ViewChild('codeField') codeField: ElementRef;
  @ViewChild('firstEngField') firstEngField: ElementRef;
  @ViewChild('lastEngField') lastEngField: ElementRef;
  keyboard: Keyboard;
  GID;
  card = new FormControl('');
  RefferDoc = new FormControl(''); // doc name
  Code = new FormControl(''); // doc id
  PRN = new FormControl(''); // הפנייה
  showPRN = false;
  showRefferDoc = false;
  showCode = false;
  param;
  isObgyn;
  isCardio;
  isGastro;
  isEyes;
  hasSeparation;
  cardtzsearch: string = '';
  idcode: string = '';
  expcode: string = '';
  swiping = false;
  error: any = false;
  AWLID;
  patient;
  activeInput: HTMLInputElement;
  success=false
  isLoading=false
  FirstEng = new FormControl(''); 
  LastEng = new FormControl(''); 
  showName=false


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public SettingsService: SettingsService,
    public PatientsService: PatientsService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.param = params['key']; 
      this.SettingsService.getClinic(this.param).subscribe(async (data: any) => {
        if (data.error) {
          return this.GID = null;
        }
        this.GID = data.GID;
        this.isCardio = data.isCardio;
        this.isGastro = data.isGastro;
        this.isEyes = data.isEyes;
        this.isObgyn = (this.isCardio || this.isEyes || this.isGastro) ? false : true;
        this.hasSeparation = data.hasSeparation;
      });
      this.initKeyboard();
      this.card.valueChanges.pipe(
        debounceTime(500)
      ).subscribe(value => this.processCard(value));
    });
  }

  initKeyboard() {
    this.keyboard = new Keyboard({
      onChange: input => this.onChange(input),
      onKeyPress: button => this.onKeyPress(button),
      ...layout,
      rtl: true,
      display: {
        "{shift}": "language", 
        "{bksp}": "delete", 
        "{enter}": "enter", 
        "{tab}": "tab", 
        "{lock}": "Caps Lock", 


      }
    });

    // Initially hide the keyboard
    this.hideKeyboard();
  }

  onChange = (input: string) => {
    if (this.activeInput) {
      this.activeInput.value = input;
      this.updateFormControlValue(input);
      this.cdr.detectChanges();  // Trigger change detection manually
    }
  };

  onKeyPress = (button: string) => {
    if (button === "{shift}" || button === "{lock}") this.handleShift();
  };

  handleShift = () => {
    let currentLayout = this.keyboard.options.layoutName;
    let shiftToggle = currentLayout === "default" ? "shift" : "default";

    this.keyboard.setOptions({
      layoutName: shiftToggle
    });
  };

  updateFormControlValue(input: string) {
    if (this.prnField && this.activeInput === this.prnField.nativeElement) {
      this.PRN.setValue(input);
    } else if (this.refferDocField && this.activeInput === this.refferDocField.nativeElement) {
      this.RefferDoc.setValue(input);
    } else if (this.codeField && this.activeInput === this.codeField.nativeElement) {
      this.Code.setValue(input);
    }else if (this.lastEngField && this.activeInput === this.lastEngField.nativeElement) {
      this.LastEng.setValue(input);
    }else if (this.firstEngField && this.activeInput === this.firstEngField.nativeElement) {
      this.FirstEng.setValue(input);
    }
    
  }

  onInputFocus(inputElement: HTMLInputElement) {
    this.activeInput = inputElement;
    this.keyboard.setInput(inputElement.value);
    this.showKeyboard();
  }

  onInputBlur() {
    // setTimeout(() => {
    //   if ((this.prnField && !this.prnField.nativeElement.contains(document.activeElement) )||
    //      (this.refferDocField &&  !this.refferDocField.nativeElement.contains(document.activeElement) )||
    //      (this.codeField &&  !this.codeField.nativeElement.contains(document.activeElement))) {
    //     this.hideKeyboard();
    //   }
    // }, 0);
   }

  showKeyboard() {
    const keyboardElement = document.querySelector('.simple-keyboard') as HTMLElement;
    if (keyboardElement) {
      keyboardElement.style.display = 'block';
    }
  }

  hideKeyboard() {
    const keyboardElement = document.querySelector('.simple-keyboard') as HTMLElement;
    if (keyboardElement) {
      keyboardElement.style.display = 'none';
    }
  }

  getCard() {
    this.card.setValue('', { emitEvent: false });
    this.cardtzsearch = '';
    this.idcode = '';
    this.expcode = '';
    this.swiping = true;
    setTimeout(() => { this.swipeField.nativeElement.focus(); }, 100);
  }

  processCard(card) {
    if (card && card.length > 26 && card.includes('8=47')) {
      card = card.substring(card.indexOf('8=47'));
    }

    if (card && card.length > 26) {
      this.cardtzsearch = card.substring(7, 16);
      this.idcode = card.substring(6, 7);
      this.expcode = card.substring(16, 20);
      this.isLoading=true
      this.PatientsService.cardioMacabiLookup(this.cardtzsearch, this.idcode, this.expcode, this.GID).subscribe(
        response => {
          this.isLoading=false
          this.error = false;
          if (response['status'] !== 'ok') {
            this.error = response['message'];
            setTimeout(() => {
              this.resetAll();
            }, 5000);
          } else {
            this.AWLID = response['data']['AWLID'];
            this.patient = response['data']['patient'];
            this.FirstEng.setValue(this.patient.FirstEng)
            this.LastEng.setValue(this.patient.LastEng)
            this.showName=true
            this.cdr.detectChanges();
           this.focus(this.firstEngField);

            
            // this.showPRN = true;
            // this.cdr.detectChanges();
            //  this.focus(this.prnField);
           
          }
        },
        error => {
          this.isLoading=false
          this.error = 'An error occurred while processing the request.';
          console.error('Error:', error);
          setTimeout(() => {
            this.resetAll();
          }, 5000);
        }
      );
    }
  }

initFocus(elementString){
  this.cdr.detectChanges();
  let element:ElementRef
  if(elementString=='lastEngField'){
    element=this.lastEngField
    }
  if(elementString=='prnField'){
    element=this.prnField
    }
  if(elementString=='refferDocField'){
  element=this.refferDocField
  }
  if(elementString=='codeField'){
    element=this.codeField
    }
  this.focus(element);
}

  focus(element:ElementRef){
    setTimeout(() => {
      element.nativeElement.focus();
    }, 0); // Delay focusing to ensure the DOM updates
  
  }



  endProcess(){
    const sanitizeInput = (input) => {
      return input.replace(/[^\d]/g, '');
  };

  // Sanitize the input values before converting to numbers
  const sanitizedCode = sanitizeInput(this.Code.value);
  const sanitizedPRN = sanitizeInput(this.PRN.value);
  const sanitizedRefDoc = this.RefferDoc.value.slice(1, -1);
  const sanitizedLastNameEng = this.sanitizeName(this.LastEng.value);
  const sanitizedFirstNameEng = this.sanitizeName(this.FirstEng.value);
  const body = {
      Code: Number(sanitizedCode),  // Now this should be a valid number
      PRN: Number(sanitizedPRN),    // Now this should be a valid number
      RefferDoc: sanitizedRefDoc,
      LastEng:sanitizedLastNameEng,
      FirstEng:sanitizedFirstNameEng,
      GID: this.GID
  };
  this.isLoading=true
    this.PatientsService.saveAWLData(this.AWLID,body).subscribe(response=>{
      this.isLoading=false
     this.success=true
     this.hideKeyboard(); 
     setTimeout(() => {
      this.resetAll();
    }, 5000);

    },error=>{
      this.isLoading=false
      this.error = 'An error occurred while processing the request.';
      console.error('Error:', error);
      setTimeout(() => {
        this.resetAll();
      }, 5000);
    })
    
  }

   sanitizeName(name: string): string {
    const firstChar = name.charAt(0);
    const lastChar = name.charAt(name.length - 1);
  
    // Regular expression to check if a character is an English letter
    const isEnglishLetter = /^[A-Za-z]$/;
  
    if (!isEnglishLetter.test(firstChar)) {
      name = name.slice(1);
    }
    if (!isEnglishLetter.test(lastChar)) {
      name = name.slice(0, -1);
    }
  
    return name;
  }

  resetAll() {
    this.cardtzsearch = '';
    this.idcode = '';
    this.expcode = '';
    this.swiping = false;
    this.error = false;
    this.card.setValue('');
    this.RefferDoc.setValue('');
    this.Code.setValue('');
    this.PRN.setValue('');
    this.AWLID = null;
    this.patient = null;
    this.showPRN = false;
    this.showRefferDoc = false;
    this.showCode = false;
    this.success=false
    this.hideKeyboard(); 
    this.isLoading=false
    this.FirstEng.setValue('')
    this.LastEng.setValue('');
    this.showName=false
  }
}
